<template>
  <Form
    ref="userProfileForm"
    :model="profile"
    :rules="rules"    
    label-position="left"
    class="form-flex middle"
    @submit.native.prevent
  >
    <slot
      v-bind="{profile}"
      name="header"
    />
    <template v-if="profile.relationship !== '10' ">
    <template v-if="profile.relationship !== '01'">
      <FullNameInput
        v-model="profile.name"
        label="姓名"
        prop="name"
        :disabled="refStore"
        :label-width="83"
      />      
      <DateVueSelect
        v-model="profile.dateOfBirth"
        label="生日"
        prop="dateOfBirth"
        :disabled="refStore"
        :label-width="83"
        age
      /> 
      <!-- <DateSelect
        :value="profile.dateOfBirth"
        label="生日"
        prop="dateOfBirth"
        :disabled="refStore"
        :label-width="83"
        age
      /> -->
      <BaseInput
        v-model="profile.identityNo"
        label="身分證字號"
        prop="identityNo"
        :disabled="refStore"
        :label-width="83"
      />
      <BaseInput
        v-model="profile.phoneNo"
        label="手機號碼"
        prop="phoneNo"
        :disabled="disPhoneNo"
        :label-width="83"
      />
      <BaseInput
        v-model="profile.mail"
        label="E-mail"
        prop="mail"
        type="email"
        :label-width="83"
      />        
        <!-- <AddressSelect
          v-model="profile.address"
          prop="address"
          :tips="addressTips"
          :label-width="83"
        /> -->
        <AddressVueSelect
          v-model="profile.address"
          prop="address"
          :tips="addressTips"
          :label-width="83"
        />
        
      </template>
    </template>
    <slot
      v-bind="{profile}"
      name="footer"
    />
  </Form>
</template>

<script>
  import { Form } from 'iview';
  import axios, { generateAuthPostConf  } from '@/utils/axios';
  import FullNameInput from './elements/FullNameInput';
  // import DateSelect from './elements/DateSelect';
  import DateVueSelect from '@/components/forms/elements/DateVueSelect';
  import AddressSelect from './elements/AddressSelect';
  import AddressVueSelect from '@/components/forms/elements/AddressVueSelect';
  import BaseInput from './elements/BaseInput';
  // form rules
  import { rules } from '@/utils/asyncValidator/userProfileForm';
 import Cookies from 'js-cookie';
  export default {
    components: { 
      Form,
      AddressSelect,
      AddressVueSelect,
      BaseInput,
      FullNameInput,
      // DateSelect,
      DateVueSelect
    },
    props: {
      model: {
        type: Object,
        default: null
      },
      rules: {
        type: Object,
        default: () => rules
      },
      refData: {
        type: String,
        default: null
      },
      refStore: {
        type: Boolean,
        default: false
      },
      addressTips: {
        type: String,
        default: null
      },
      disPhoneNo: {
        type: Boolean,
        default: false
      },
      details: {
        type: Object,
        default: null
      }
    },
    data() {
      const profile = this.$cloneDeep(this.model);
      //profile=details;     
      return {
        profile
      };
    },
    beforeMount() 
    {   
    const cid = Cookies.get('cid');
      //console.log("initPartner-reviews"+JSON.stringify(cid));   
      if(cid!=undefined ||cid!=null)
      {
        this.initPartner(cid);
      }
    },    
    methods: {
      validate() {
        return this.$refs.userProfileForm.validate(valid => valid);
      },
      async getPayload() {
        const isValid = await this.validate();
        if (!isValid) return;
        return this.profile;
      },
      async initPartner(cid) {          
        const orderId= cid;   
      //  console.log("initPartner-orderId:"+JSON.stringify(orderId));            
        //console.log("codeId:"+orderid);
        const config = generateAuthPostConf('tokenGet',{orderId});//generateAuthPostConf('tokenVerify',{cid});
        const { data } = await axios(config);
        const {  message, success } = data; 
        //console.log("initPartner-partner:"+JSON.stringify(data.result));  
        //console.log("initPartner-partner2:"+JSON.stringify(data));  
        if (!data)
        {}
        else{      
        this.details=data;
        //console.log("initPartner-partner1:"+JSON.stringify(this.details));   
           
        this.profile.name.firstName=this.details.customers_firstname;
        //this.devModel.name.firstName=this.details.customers_firstname;
        this.profile.name.lastName=this.details.customers_lastname;
        this.profile.identityNo= this.details.customers_identity;        
        this.profile.phoneNo=this.details.customers_cell;
        if (this.details.customers_email_address!=undefined){
        this.profile.mail= this.details.customers_email_address;
        } 
        this.profile.RefAgent=this.details.ref_id;
        //let dt = new Date(Date.parse(this.details.customers_dob.replace(/-/g,"/")));;
        let date1= new Date(this.details.customers_dob);
        //console.log("=new Date(this.details.customers_dob):"+dt);
        //console.log("=new Date(this.details.customers_dob).month:"+(date1.getMonth()+1).toString().padStart(2,'0')+"/"+date1.getDate().toString().padStart(2,'0'));
        this.profile.dateOfBirth.year=date1.getFullYear().toString();
        this.profile.dateOfBirth.month=(date1.getMonth()+1).toString().padStart(2,'0');
        this.profile.dateOfBirth.day=(date1.getDate()).toString().padStart(2,'0');        
        this.profile.address.city=this.details.customers_city;
        this.profile.address.area=this.details.customers_zone;
        //zip
        this.profile.address.road=this.details.customers_street_address;
        if (this.profile.homeAddress!=undefined){
        if (this.details.customers_residence_address=='' ){
          this.profile.homeAddress.city=this.details.customers_city;
          this.profile.homeAddress.area=this.details.customers_zone;
        //zip
          this.profile.homeAddress.road=this.details.customers_street_address; 
        }else
        {
        this.profile.homeAddress.city=this.details.customers_residence_city;
        this.profile.homeAddress.area=this.details.customers_residence_zone;
        //zip
        this.profile.homeAddress.road=this.details.customers_residence_address;         
        }
        }
         this.profile.RefAgent=this.details.ref_id;
        //console.log("initPartner-customers_residence_address:"+JSON.stringify(this.details.customers_residence_address));         
        }          
      },
      handleReset() {
        return this.$refs.userProfileForm.resetFields();
      }
    }
  };
</script>
